import gql from 'graphql-tag';
import client from '../../client';
const SETUP_MONEY_PLATFORM_PAYMENT = gql `
    mutation SetupMoneyPlatformPayment($input: any) {
        setupPaymentMethod(input: $input) @rest(type: "SetupPaymentMethod", path: "payments/setup", method: "POST") {
            data {
                createdAt
                default
                id
                paymentMethod {
                    key {
                        card {
                            brand
                            exp_month
                            exp_year
                            fingerprint
                            funding
                            last4
                        }
                        id
                        provider
                    }
                }
                processor
                updatedAt
                userId
            }
        }
    }
`;
const editMoneyPlatformPayment = (token, profileId) => {
    const variables = {
        input: {
            moneyPlatformRelease: true,
            paymentProvider: 'MONEYPLATFORM',
            token: token,
            userId: profileId,
        },
    };
    return client.mutate({
        mutation: SETUP_MONEY_PLATFORM_PAYMENT,
        variables
    });
};
export { editMoneyPlatformPayment };
